import React from 'react'
import { motion } from "framer-motion";
import { FaBriefcase } from "react-icons/fa";
import { yearsOfExperience } from "../../constants";
import { iconFor } from "../layouts/techIcons";
import AvatarCore from "./AvatarCore";

// Two rings of tech icons orbiting the monogram. `r` is the ring radius in % of the box.
const rings = [
  { r: 33, duration: 28, items: ["React", "Node.js", "TypeScript", "NestJS"] },
  { r: 46, duration: 44, reverse: true, items: ["AWS", "OpenAI", "PostgreSQL", "DynamoDB", "Docker", "GraphQL"] },
];

const floatAnim = (delay) => ({
  animate: { y: [0, -10, 0] },
  transition: { duration: 4, repeat: Infinity, ease: "easeInOut", delay },
});

const Ring = ({ r, duration, reverse, items }) => (
  <div
    className="orbit absolute inset-0"
    style={{ animationDuration: `${duration}s`, animationDirection: reverse ? "reverse" : "normal" }}
  >
    <div
      className="absolute rounded-full border border-dashed border-white/10"
      style={{ inset: `${50 - r}%` }}
    ></div>
    {items.map((name, i) => {
      const angle = (i / items.length) * 2 * Math.PI;
      return (
        <div
          key={name}
          className="absolute -translate-x-1/2 -translate-y-1/2"
          style={{ left: `${50 + r * Math.cos(angle)}%`, top: `${50 + r * Math.sin(angle)}%` }}
        >
          {/* counter-rotate so icons stay upright */}
          <div
            className="orbit"
            style={{ animationDuration: `${duration}s`, animationDirection: reverse ? "normal" : "reverse" }}
          >
            <span
              title={name}
              className="w-11 h-11 lgl:w-14 lgl:h-14 rounded-2xl bg-[#23272b]/90 backdrop-blur border border-white/10 text-gray-200 text-xl lgl:text-2xl inline-flex items-center justify-center shadow-lg shadow-black/40 hover:text-designColor hover:border-designColor/50 duration-300"
            >
              {iconFor(name)}
            </span>
          </div>
        </div>
      );
    })}
  </div>
);

const RightBanner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      className="w-full lgl:w-[45%] flex justify-center items-center relative z-10"
    >
      <div className="relative w-[320px] h-[320px] sml:w-[400px] sml:h-[400px] lgl:w-[520px] lgl:h-[520px]">
        <div className="absolute inset-[20%] rounded-full bg-designColor/25 blur-3xl"></div>
        {rings.map((ring) => (
          <Ring key={ring.r} {...ring} />
        ))}
        {/* core */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <AvatarCore />
        </div>
        <motion.div
          {...floatAnim(0)}
          className="absolute z-20 left-0 top-[4%] lgl:-left-4 card px-3 py-2 lgl:px-4 lgl:py-3 hidden sml:flex items-center gap-3"
        >
          <span className="w-10 h-10 rounded-xl bg-designColor/15 text-designColor inline-flex items-center justify-center">
            <FaBriefcase />
          </span>
          <div>
            <p className="text-white font-bold leading-none">{yearsOfExperience} years</p>
            <p className="text-xs text-gray-400 mt-1">Engineering experience</p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default RightBanner
